import React, { useState, useEffect } from 'react';
import logo from '../assets/Asset 1.svg'
function PortfolioNav() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('hero');

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);

            // Intersection Observer could be better, but scroll-based logic for active section
            const sections = ['hero', 'about', 'skills', 'projects', 'experience', 'contact'];
            const current = sections.find(section => {
                const element = document.getElementById(section);
                if (element) {
                    const rect = element.getBoundingClientRect();
                    return rect.top <= 100 && rect.bottom >= 100;
                }
                return false;
            });
            if (current) setActiveSection(current);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navLinks = [
        { name: 'Home', href: '#hero', id: 'hero' },
        { name: 'About', href: '#about', id: 'about' },
        { name: 'Skills', href: '#skills', id: 'skills' },
        { name: 'Projects', href: '#projects', id: 'projects' },
        { name: 'Experience', href: '#experience', id: 'experience' },
        { name: 'Contact', href: '#contact', id: 'contact' },
    ];

    const scrollToSection = (e, href) => {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
            const offset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
            setIsMobileMenuOpen(false);
        }
    };

    return (
        <nav
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled
                    ? 'glass-nav py-3'
                    : 'bg-transparent py-6'
                }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <div className="flex justify-between items-center">

                    {/* Logo */}
                    <div className="flex items-center">
                        <a href="#hero" onClick={(e) => scrollToSection(e, '#hero')} className="flex items-center gap-3 group">
                            <div className="w-11 h-11 rounded-2xl text-black flex items-center justify-center font-black text-xl shadow-[0_0_20px_rgba(71,232,2,0.4)] transition-transform duration-300 group-hover:rotate-12">
                                <img src={logo} alt="logo" className='w-full h-full object-cover' />
                            </div>
                            <span className="font-extrabold text-2xl text-white tracking-tighter">
                               KWAGALA MORIS OWEN<span className="text-green-500 font-space-grotesk">.</span>
                            </span>
                        </a>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center gap-2">
                        <ul className="flex items-center gap-1 bg-white/5 p-1 rounded-2xl backdrop-blur-md border border-white/5">
                            {navLinks.map((link) => (
                                <li key={link.name}>
                                    <a
                                        href={link.href}
                                        onClick={(e) => scrollToSection(e, link.href)}
                                        className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300 ${activeSection === link.id
                                                ? 'bg-green-500 text-black shadow-lg'
                                                : 'text-gray-400 hover:text-white hover:bg-white/5'
                                            }`}
                                    >
                                        {link.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            className="p-3 bg-white/5 rounded-2xl text-white hover:bg-white/10 transition-colors border border-white/10"
                        >
                            <i className={`text-2xl bi ${isMobileMenuOpen ? 'bi-x-lg' : 'bi-grid-3x3-gap-fill text-green-500'}`}></i>
                        </button>
                    </div>

                </div>
            </div>

            {/* Mobile Navigation Menu */}
            <div className={`md:hidden absolute top-full left-4 right-4 mt-4 glass-card rounded-3xl transition-all duration-500 origin-top overflow-hidden ${isMobileMenuOpen ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 -translate-y-4 scale-95 pointer-events-none'
                }`}>
                <ul className="flex flex-col p-4 gap-2">
                    {navLinks.map((link) => (
                        <li key={link.name}>
                            <a
                                href={link.href}
                                onClick={(e) => scrollToSection(e, link.href)}
                                className={`block py-4 px-6 rounded-2xl text-lg font-bold transition-all duration-300 ${activeSection === link.id
                                        ? 'bg-green-500 text-black'
                                        : 'text-gray-300 hover:bg-white/5'
                                    }`}
                            >
                                {link.name}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>

        </nav>
    );
}

export default PortfolioNav;
